export const environment = {
  production: true,
  uriRedirectToHomeEN: 'https://miles-tc.milesbynovae.com/#/home?lang=en',
  uriRedirectToHomeES: 'https://miles-tc.milesbynovae.com/#/home?lang=es',
  subdomainBrands: {
    home: 'miles-tc.',
    ncb: 'ncb-tc.',
    firstCitizens: 'fc-tc.',
    myrewards: 'mr-tc.',
    lifemiles: 'lifemiles-tc.',
    cibc: 'cibcfcib-tc.',
    lifemilesMoreRate: 'lmtravel-tc.',
    credomatic: 'bac-tc.',
    apap: 'apap-tc.',
    scotia: 'scotia-tc.',
    popular: 'bpopular-tc.',
    milesBlue: 'tc.milesblue.',
    cryptmi: 'tc.cryptmi.com',
    milescare: 'milescare-tc.',
    chn: 'tc.chnmyrewards.com',
    cuscatlan: 'tc.cuscatlanmyrewards.com',
    dev: 'devtc.allegra.tech',
    imagine: 'tc.imagineas.one',
    one: 'tc.mcasone.com',
    localhost: 'localhost'
  },
  configLanguageBrand: {
    default: 'en',
    apap: {
      languageDefault: 'es'
    },
    credomatic: {
      languageDefault: 'es'
    },
    lifemilesMoreRate: {
      languageDefault: 'es'
    },
    lifemiles: {
      languageDefault: 'es'
    },
    ncb: {
      languageDefault: 'es'
    },
    home: {
      languageDefault: 'en'
    },
    chn: {
      languageDefault: 'es'
    },
    cuscatlan: {
      languageDefault: 'es'
    },
    one: {
      languageDefault: 'en'
    },
    localhost: {
      languageDefault: 'es'
    }
  }
};
